import { render, staticRenderFns } from "./ModalOrcamento.vue?vue&type=template&id=53f96b3a&"
import script from "./ModalOrcamento.vue?vue&type=script&lang=js&"
export * from "./ModalOrcamento.vue?vue&type=script&lang=js&"
import style0 from "./ModalOrcamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports